var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('InfoTable',{attrs:{"title":"Overview"}},[_c('InfoWithOutTable',{attrs:{"title":"WordPress","content":_vm.wpVersion}}),_c('InfoWithOutTable',{attrs:{"title":"Storage","content":_vm.availableStorage}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }